import i18n from 'i18next';
import languageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import locales from 'src/locales';

import { PRIMARY_LANG, SECONDARY_LANG } from './localization.consts';

const detectorOptions = {
  caches: ['localStorage', 'cookie'],
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupQuerystring: 'lng',
  order: ['localStorage', 'cookie', 'querystring', 'path'],
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [PRIMARY_LANG, SECONDARY_LANG],
    detection: detectorOptions,
    defaultNS: 'common',
    fallbackLng: PRIMARY_LANG || 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    resources: locales,
  });

export default i18n;
